import type { ReactNode } from 'react';
import cn from '@/utils/merge-class-names';
import { AvatarWithStatus } from '../common/avatar-with-status';

type FriendUserHeroProps = {
  avatarUrl?: string;
  name?: string;
  addOn?: ReactNode;
  className?: string;
};

export default function FriendUserHero({ avatarUrl, name = '', addOn, className }: FriendUserHeroProps) {
  return (
    <div className={cn('relative rounded w-full', className)}>
      <div className={cn('flex flex-start items-center gap-4 rounded px-6', className)}>
        <AvatarWithStatus
          imageUrl={avatarUrl}
          className='size-20 desktop:size-18 ring-1 ring-neutral-0 basis-16 shadow'
          size={[64, 64]}
        />

        <div className='flex flex-col flex-1 basis-16 mb-1 justify-center items-start gap-2 desktop:gap-0 text-body'>
          <h2 className='font-bold'>{name}</h2>
        </div>

        {addOn}
      </div>
    </div>
  );
}
